export default __webpack_public_path__ + "static/media/aboutUs.267ff6ac.png";